var React = require('react');

function IconMeasureProgress (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M-9.38135e-10 14.5025L10.15 17.9213L17.3812 11.6213L11.55 18.6213L16.5089 20.36L23.0259 22.8393L28 0.0712891L-9.38135e-10 14.5025ZM11.55 18.6213L14.2739 19.5764L16.5089 20.36L12.1836 28.0713L11.55 18.6213Z","fill":"#2B376B"}));
}

IconMeasureProgress.defaultProps = {"width":"28","height":"29","viewBox":"0 0 28 29","fill":"none"};

module.exports = IconMeasureProgress;

IconMeasureProgress.default = IconMeasureProgress;
